export default {
  AUTH_MEMBER: 'AUTH_MEMBER',
  EMAIL: 'EMAIL',
  DRAFT_OF_BAG: 'DRAFT_OF_BAG',
  ORDER_CREATE_INFO: 'ORDER_CREATE_INFO',
  EDIT_COMMODITY: 'EDIT_COMMODITY',
  SCROLL_POSITION: 'SCROLL_POSITION',
};
